import { Controller } from 'stimulus';
import confirmDialog from '@/js/modules/confirm_dialog';

export default class extends Controller {
  // The client's current team: a link only because the menu primitive renders links.
  ignore(event) {
    event.preventDefault();
  }

  async confirmSwitch(event) {
    event.preventDefault();

    const { name, url } = event.params;
    const confirmed = await confirmDialog(
      `Switching to ${name} will allow you to access any project(s) you have with this company.`,
      { title: 'Switch Designer', button: 'Confirm Switch', danger: false, keepOpen: true }
    );

    if (confirmed) {
      window.location.assign(url);
    }
  }
}
